import * as React from 'react';
import Select, {
	SelectValue,
} from '../../../../../Components/Base/Select/Select';
import { useTermItemsQuery } from '../../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import { useMemo, useState } from 'react';
import Loading from '../../../../../Components/Loading';
import useTranslation from '../../../../../Hooks/useTranslation';
import useSelectValueGuard from '../../../Hooks/useSelectValueGuard';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
	valueKey?: 'id';
}

const QuestionnaireScheduleFrequencySelect: React.FC<Props> = props => {
	const { value, onChange, valueKey } = props;
	const { data, isLoading } = useTermItemsQuery({
		termType: 'gender',
		take: 999,
	});
	const [defaultValue, setDefaultValue] = useState(value);
	const { t } = useTranslation();

	const options: SelectValue[] = useMemo(() => {
		const items: SelectValue[] = [];

		for (const termItem of data?.termItems?.data || []) {
			if (termItem && termItem.value) {
				items.push({
					value: valueKey ? termItem[valueKey] : termItem.value,
					label: termItem.name || termItem.id || '',
				});
			}
		}

		return items;
	}, [data]);

	useSelectValueGuard({ options, value, onChange });

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			{...props}
			onChange={onChange}
			placeholder={t('base.shared.pick')}
			value={defaultValue?.label ? defaultValue : value}
			showErrorMessage={false}
		/>
	);
};

export default QuestionnaireScheduleFrequencySelect;
